import { Box, BoxProps } from "@chakra-ui/react";
import { useMediaBlob } from "../../lib/mediaHelpers";
import { useMeasuredVariantPath } from "../../lib/profileMedia";
import { Loader } from "../Loader/Loader";
import { Alert } from "../Alert/Alert";

interface MediaImageProps extends BoxProps {
  path: string;
}
export const MediaImage = ({ path, children, ...props }: MediaImageProps) => {
  const [setMeasureRef, resolvedPath] = useMeasuredVariantPath(path);
  const { loading, blob, error } = useMediaBlob(resolvedPath ?? "");
  return (
    <Box borderRadius="0.3125rem" width="100%" overflow="hidden" {...props}>
      <Box
        ref={setMeasureRef}
        style={{
          aspectRatio: 1,
          backgroundImage:
            !loading && blob ? `url(${URL.createObjectURL(blob)}` : undefined,
          backgroundSize: "cover",
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {loading ? (
          <Loader />
        ) : error ? (
          <Alert intent="danger" title={error} />
        ) : (
          children
        )}
      </Box>
    </Box>
  );
};
